import React, {useEffect, useState} from 'react';
import { Loader } from "semantic-ui-react";
import { size, map } from "lodash";
import { Grade } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { GradeItem } from "../GradeItem";

const gradeController = new Grade();

export function ListGrade(props) {

  const { reload, onReload } = props;
  const [grades, setGrades] = useState(null);
  const { accessToken } = useAuth();

  useEffect(() => {
    (async () => {
      try {
        setGrades(null);
        const response = await gradeController.getGrades(accessToken);
        setGrades(response);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [reload, accessToken]);

  if (!grades) return <Loader active inline="centered" />;
  if (size(grades) === 0) return "No existen grados registradas";

  return map(grades, (grade) => (
    <GradeItem key={grade.id} grade={grade} onReload={onReload} />
  ));
}
